import { dataHooks } from '@wix/data-hooks'

export const wixStudioCreateDataHooks = dataHooks<{
  links: { id: string }
}>('wixStudioCreate')
